import each from 'lodash/each';
import find from 'lodash/find';
import Backbone from 'backbone';

import { getUrl } from 'zoomforth_codesbane_viewer/lib/app_actions.js';

/*
  Some Backbone minutiae to help you understand:

  - `Backbone.History` is the class which captures / wraps the window.location state data
    and intermediates between it and your backbone router.
  - `Backbone.history` is hardcoded to `new Backbone.History()` in the Backbone lib. 
*/


// Properties we need to copy from a Backbone.History object to
// represent its state in a new Backbone.History object
const HISTORY_STATE_COPY_PROPS = [ 
  'options',
  'root',
  '_wantsHashChange',
  '_hasHashChange',
  '_useHashChange',
  '_wantsPushState',
  '_hasPushState',
  '_usePushState'
];

/*
  Get the route handlers in the current Backbone.history instance
*/
export const getHandler = (urlFragment)=> {

  const handler = find(Backbone.history.handlers, handler => 
    handler.route.test(urlFragment)
  );
  return handler;
};


/*
  Given a URL extract from it a "Backbone"-like URL path fragment
*/
export const getUrlFragment = (url)=> {
  // Create a temporary Backbone History object
  const tempHistory = new Backbone.History();
  // We want to replicate the behavior of our real history object as much as possible
  // (while not calling `.start()` so we monkey patch current values from
  // the real history object to our temporary one
  each(HISTORY_STATE_COPY_PROPS, copyProp => {
    // Note: I dont know if this truly represents all the state captured
    // by the Backbone.History object, but it works for our limited use case
    // thus far
    tempHistory[copyProp] = Backbone.history[copyProp];
  });

  // Monkey patch a dummy anchor tag into the History objects "location" reference
  // (the `<a>` tag element has *roughly* the same API as a window.location object)
  const a = document.createElement('a');
  a.href = url;
  tempHistory.location = a;
  // Now when we query the history object for information and it will extract it
  // from the URL we have specified rather than the current `window.location`

  return tempHistory.getFragment();
};


/*
  Given any URL, determine if the Backbone URL fragment for that URL
  would generate a hash change, if so, do nothing. Otherwise,
  call the route which matches that URL fragment—thus simulating a route
  match.
*/
export const executeMatchedRouteIfSameHashOnMenuItemClick = (menuItem)=> {
  const url = getUrl(menuItem.appAction);
  const newUrlFragment = getUrlFragment(url);
  const currentUrlFragment = Backbone.history.getFragment(); // Routers current

  if (newUrlFragment === currentUrlFragment) {
    // We clicked on something that wont result in a hashchange occurring,
    // we will miss out on an automatic router hit--so we fake a router hit!
    const handler = getHandler(newUrlFragment);
    handler.callback(newUrlFragment);
  }
};

